import './linear-loader.scss';

const LinearLoader: React.FC = () => {
    return <div className="loader linear-loader">
        <div className="linear-activity">
            <div className="indeterminate"></div>
        </div>
    </div>
}

export default LinearLoader;
